export const toggleLoading = (flag, message) => (dispatch) => {
  dispatch({ type: "TOGGLE_LOADING", payload: { flag, message } });
};

export const loadingSkeleton = (flag, message) => (dispatch) => {
  dispatch({ type: "SKELETON_LOADING", payload: { flag } });
};
